export default "__VITE_ASSET__DroUzvzD__"